import React from 'react';
import { 
  CheckCircle, 
  Clock, 
  AlertTriangle, 
  TrendingUp,
  BarChart3,
  Flag
} from 'lucide-react';

/**
 * TaskStatsCards - Display task statistics in card format
 */
const TaskStatsCards = ({ stats }) => {
  if (!stats) return null;

  const statCards = [
    {
      name: 'Total Tasks',
      value: stats.total || 0,
      icon: BarChart3,
      color: 'blue',
      description: 'All tasks in system'
    },
    {
      name: 'Completed',
      value: stats.by_status?.completed || 0,
      icon: CheckCircle,
      color: 'green',
      description: 'Successfully completed'
    },
    {
      name: 'In Progress',
      value: stats.by_status?.in_progress || 0,
      icon: Clock,
      color: 'blue',
      description: 'Currently being worked on'
    },
    {
      name: 'Overdue',
      value: stats.overdue || 0,
      icon: AlertTriangle,
      color: 'red',
      description: 'Past due date'
    },
    {
      name: 'High Priority',
      value: (stats.by_priority?.critical || 0) + (stats.by_priority?.high || 0),
      icon: Flag,
      color: 'orange',
      description: 'Critical and high priority'
    },
    {
      name: 'This Week',
      value: stats.created_this_week || 0,
      icon: TrendingUp,
      color: 'purple',
      description: 'Created this week'
    }
  ];

  const getColorClasses = (color) => {
    switch (color) {
      case 'blue':
        return {
          bg: 'bg-blue-50',
          text: 'text-blue-600',
          icon: 'text-blue-600'
        };
      case 'green':
        return {
          bg: 'bg-green-50',
          text: 'text-green-600',
          icon: 'text-green-600'
        };
      case 'red':
        return {
          bg: 'bg-red-50',
          text: 'text-red-600',
          icon: 'text-red-600'
        };
      case 'orange':
        return {
          bg: 'bg-orange-50',
          text: 'text-orange-600',
          icon: 'text-orange-600'
        };
      case 'purple':
        return {
          bg: 'bg-purple-50',
          text: 'text-purple-600',
          icon: 'text-purple-600'
        };
      default:
        return {
          bg: 'bg-gray-50',
          text: 'text-gray-600',
          icon: 'text-gray-600'
        };
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
      {statCards.map((stat) => {
        const Icon = stat.icon;
        const colors = getColorClasses(stat.color);
        
        return (
          <div
            key={stat.name}
            className="bg-white overflow-hidden shadow rounded-lg border border-gray-200"
          >
            <div className="p-5">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <div className={`w-8 h-8 ${colors.bg} rounded-md flex items-center justify-center`}>
                    <Icon className={`h-5 w-5 ${colors.icon}`} />
                  </div>
                </div>
                <div className="ml-4 w-0 flex-1">
                  <dl>
                    <dt className="text-sm font-medium text-gray-500 truncate">
                      {stat.name}
                    </dt>
                    <dd className={`text-2xl font-semibold ${colors.text}`}>
                      {stat.value.toLocaleString()}
                    </dd>
                  </dl>
                </div>
              </div>
              <div className="mt-2">
                <p className="text-xs text-gray-500">{stat.description}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TaskStatsCards;